<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  @if (user | hasEitherPerm: ['cauth.add_user']) {
    <div class="top-menu mx-2">
      <div tuiDropdownOpen [tuiDropdownMaxHeight]="700" [tuiDropdown]="umenu">
        <tui-icon [icon]="'mat::add'" class="tm-icon"></tui-icon>
      </div>
    </div>

    <ng-template #umenu>
      <tui-data-list role="menu">
        <tui-opt-group>
          @if (user | hasAllPerms: ['cauth.add_user']) {
            <a class="m-option" tuiOption (click)="qaUser()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'@tui.user'"></tui-icon>
                </div>
                <div class="m-option-text mx-3" i18n>User</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ['core.add_company']) {
            <a class="m-option" tuiOption (click)="qaCompany()">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'mat::company'"></tui-icon>
                </div>
                <div class="m-option-text mx-3" i18n>Company</div>
              </div>
            </a>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  }
}
